import "./App.css";
import Header from "./components/header/Header";
import Navigation from "./components/navigation/Navigation";
import About from "./pages/About";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Footer from "./components/footer/Footer";
import MobileApp from "./components/mobileApp/MobileApp";
import Product from "./components/product/Product";
import Checkout from "./components/checkout/Checkout";
import Order from "./components/order/Order";
import FooterHeader from "./components/footerHeader/FooterHeader";
import SideBar from "./components/sideBar/SideBar";
import DrawerCart from "./components/drawer/Drawer";
import Search from "./components/search/Search";
import Login from "./components/login/Login";
import Register from "./components/register/Register";
import { Fragment, useEffect, useState } from "react";
import User from "./components/user/User";
import Dashboard from "./components/dashboard/Dashboard";
import ChangePassword from "./components/changePassword/ChangePassword";
import MyOrders from "./components/myOrders/MyOrders";
import UpdateProfile from "./components/updateProfile/UpdateProfile";
import Offers from "./pages/Offers";
import ForgotPassowrd from "./components/login/ForgotPassowrd";
import PasswordReset from "./components/login/PasswordReset";
import VendorRegister from "./components/register/VendorRegister";
import ThankYouForRegistering from "./pages/ThankYouRegistering";
import AllProducts from "./components/productList/AllProducts";
import AgePopup from "./pages/AgePopup";
import ShopByBrands from "./components/productList/ShopByBrands";
import ShopByCategory from "./components/productList/ShopByCategory";
import Privacy from "./pages/PrivacyPolicy";
import Refund from "./pages/Refund";
import Return from "./pages/Return";
import Terms from "./pages/Terms";
import Wholesale from "./pages/Wholesale";
import AnnouncementPopup from "./pages/AnnouncementPopup";


function App() {
  let [isOpenRegister, setIsOpenRegister] = useState(false);
  let [isOpenForgotPassword, setIsOpenForgotPassword] = useState(false);
   const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-G44K9ZPPCB', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return (
    <Fragment>
      <Header />
      <Navigation />

      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="about-us" element={<About />} />
        <Route path="contact-us" element={<Contact />} />
        <Route path={"product/:id"} element={<Product />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="search" element={<Search />} />
       <Route path="/register" element={<Register />} />
         <Route path="/login" element={<Login />} />
        <Route path={"order/:id"} element={<Order />} />
        <Route path="offer" element={<Offers />} />
        <Route path="shop" element={<AllProducts />} />
        <Route path="vendor-registration" element={<VendorRegister />} />
        <Route path="registration-complete" element={<ThankYouForRegistering />} />
        <Route path="forget-password/:token" element={<PasswordReset />} />
        <Route path="popup" element={<AgePopup />} />
        <Route path="announcement-popup" element={<AnnouncementPopup />} />
        <Route path="shopByBrands" element={<ShopByBrands />} />
        <Route path="shopByCategory" element={<ShopByCategory />} />
         <Route path="privacy-policy" element={<Privacy />} />
         <Route path="refund-policy" element={<Refund />} />
         <Route path="return-policy" element={<Return />} />
         <Route path="terms-and-conditions" element={<Terms />} />
         <Route path="wholesale" element={<Wholesale />} />


        {/* ------------------------------ */}
        <Route path="user" element={<User />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="my-orders" element={<MyOrders />} />
          <Route path="update-profile" element={<UpdateProfile />} />
          <Route path="change-password" element={<ChangePassword />} />
       
        </Route>
        <Route path="*" element={<Home />} />
      </Routes>
      <div>
        <FooterHeader />
      </div>
      <div>
        <SideBar />
        <DrawerCart />
        <Login setIsOpenRegister={setIsOpenRegister} setIsOpenForgotPassword={setIsOpenForgotPassword} />
        <Register
          isOpen={isOpenRegister}
          setIsOpenRegister={setIsOpenRegister}
        />
        <ForgotPassowrd
          isOpen={isOpenForgotPassword}
          setIsOpenForgotPassword={setIsOpenForgotPassword}
        />
      </div>
      <div className="w-full">
        <MobileApp />
        <Footer />
      </div>
    </Fragment>
  );
}

export default App;
